import api from '../client'

export const personalizedBetsApi = {
  list: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/posts`, {
      params: { ...params, origin: params.origin || 'personalized' },
    })
    return response.data
  },

  getStatus: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/personalized-bets/status`)
    return response.data
  },

  getPolicy: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/personalized-bets/policy`)
    return response.data
  },

  updatePolicy: async (orgId, policy) => {
    const response = await api.patch(`/organizations/${orgId}/personalized-bets/policy`, policy)
    return response.data
  },
}
